import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { i18n } from "@lingui/core";
import { messages as enMessages } from "./locales/en/messages";
import { messages as nlMessages } from "./locales/nl/messages";
import { messages as ruMessages } from "./locales/ru/messages";
import { LanguageProvider } from './components/LanguageProvider';

i18n.load({
  en: enMessages,
  ru: ruMessages,
  nl: nlMessages,
});

const lng = localStorage.getItem('LANGUAGE') || "en"
i18n.activate(lng);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LanguageProvider>
    <App />
  </LanguageProvider>
);